const initialState = { 
  loading: false,
  success: null,
  error: null
}

function updateSettingReferralReducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_SETTING_REFERRAL_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'UPDATE_SETTING_REFERRAL_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'UPDATE_SETTING_REFERRAL_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default updateSettingReferralReducer
